import { ClinicianVendorEnumProto_Value } from "@noom/noom-contracts/noom_contracts/healthcare/model/clinician_vendor";

export enum TelehealthIntakeTheme {
  HRT = "HRT",
  Default = "Default",
}

export const getTelehealthIntakeTheme = (
  clinicianVendor: ClinicianVendorEnumProto_Value
): TelehealthIntakeTheme => {
  if (clinicianVendor === "MD_INTEGRATIONS_OBGYN") {
    return TelehealthIntakeTheme.HRT;
  }

  return TelehealthIntakeTheme.Default;
};
